import OngoingOrdersProvider from './OngoingOrdersProvider';

export default {
  OngoingOrdersProvider,
};
